<mat-dialog-content class="mat-typography">
    <div style="width: 450px; text-align: center;">
        <h3>{{title}}</h3>
    </div>
    <div class="row">
        <div class="col-md-12">
            <app-grid-component style="width: 100%;"
                [datos]="facturas"
                [columns]="columns"
                [exportExcel]="objetoGridConfiguration.ExportExcel"
                [columnHiding]="objetoGridConfiguration.ColumnHiding"
                [Checkbox]="objetoGridConfiguration.Checkbox"
                [Editing]="objetoGridConfiguration.Editing"
                [Columnchooser]="objetoGridConfiguration.Columnchooser"
                [searchPanel]="objetoGridConfiguration.SearchPanel"
                [scroll]="objetoGridConfiguration.Scroll"
                [toolbar]="[]"
                (datosevent)='datosMessage($event)'>
            </app-grid-component>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="cancelRelacion()" [mat-dialog-close]="retornarValores">Cancelar</button>
    <button mat-button (click)="addRelacion()" [mat-dialog-close]="retornarValores" cdkFocusInitial>Relacionar</button>
</mat-dialog-actions>


<!-- <div class="float-right">
    <button button class="flotanteDerecha accent" mat-raised-button type="button" (click)='cancelar()'>Cerrar</button>
</div> -->
